import { RecurringPeriodType } from "../../../../common/enums";
import {
  RecurringPeriodTypeLabels,
} from "../../../../common/labels";

export const getRecurringPeriodType = () => {
  const recurringPeriodType = [
    {
      id: RecurringPeriodType.Weeks,
      name: RecurringPeriodTypeLabels[RecurringPeriodType.Weeks],
    },
    {
      id: RecurringPeriodType.Months,
      name: RecurringPeriodTypeLabels[RecurringPeriodType.Months],
    },
  ];

  return recurringPeriodType;
};
